<template>
  <div>
    <v-row class="flex mt-5 mb-5 p-0 m-0">
      <v-col cols="12" class="flex justify-center pb-0">
        <div style="font-size: 60px; color: #ccc; margin-bottom: 14px;">
          <v-icon icon="far fa-exclamation-circle" />
        </div>
      </v-col>
      <v-col cols="12 mt-0 pt-0">
        <div style="text-align: center; font-size:15px; color: #888;">
          <slot>
            {{ text1 ? text1 : '해당하는 내용이 없습니다' }}
            <template v-if="text2">
              <br>{{ text2 }}<br><br>
            </template>
          </slot>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';

library.add(faExclamationCircle)

const props = defineProps<{
  text1?: string,
  text2?: string
}>()



</script>